import axios from 'axios';
const getcfg = 'getcfg'; // 基础配置
const getinfo = 'getinfo'; // 个人信息
const getrole = 'getrole'; // 角色列表
const bindrole = 'bindrole'; // 绑定角色
const cjlog = 'cjlog'; // 幸运勇士

const cj = 'cj'; // 摇一摇
const addr = 'addr'; // 保存地址
const getaddr = 'getaddr'; // 获取用户已填地址

const checkin = 'checkin'; // 每日签到
const dayinvite = 'dayinvite'; // 每日邀请
const dayactive = 'dayactive'; // 每日活跃度
const invite = 'invite'; // 是否邀请成功

const url = '/act/may_day_2020/api/index.php?act=';
function fetch(
  url,
  type,
  data,
  cb
) {
  const params = data || {};

  return axios({
    method: (type === '' || type === 'get') ? 'get' : 'post',
    url: url,
    params
  }).then((resp) => {
    cb(resp.data);
  }, (err) => {
    alert(err);
  })
}
export default {
  /**
   * 记录邀请关系
   * @returns {*|Promise|Promise.<T>|Promise.<U>}
   */
  inVite(f) {
    return fetch(url + invite + '&f=' + f, '', { }, (data) => {

    });
  },
  /**
   * 获取积分
   * @returns {*|Promise|Promise.<T>|Promise.<U>}
   */
  checKin(vm) {
    return fetch(url + checkin, '', { }, (data) => {
      if (data.status === 1) {
        vm.day_login_act = 1;
        vm.actionsClick('showTcc', 'tips3');
        vm.score += 2;
        document.querySelector('#getLq').className += ' on';
        document.querySelector('#getLq').textContent = '已领取';
      } else {
        alert(data.msg);
      }
    });
  },
  dayInvite(vm) {
    return fetch(url + dayinvite, '', { }, (data) => {
      if (data.status === 1) {
        document.querySelector('#toOver').className += ' on';
        document.querySelector('#toOver').textContent = '已领取';
        vm.score += 3;
        vm.actionsClick('showTcc', 'tips4');
      } else {
        alert(data.msg);
      }
    });
  },
  dayActive(vm) {
    return fetch(url + dayactive, '', { }, (data) => {
      if (data.status === 1) {
        document.querySelector('#toLq').className += ' on';
        vm.actionsClick('showTcc', 'tips5');
        vm.score += 5;
      } else if (data.status === -3) {
        vm.actionsClick('showTcc', 'binding');
      } else {
        alert(data.msg);
      }
    });
  },

  /**
   * 抽奖
   * @returns {*|Promise|Promise.<T>|Promise.<U>}
   */
  Cj(vm) {
    return fetch(url + cj, '', { }, (data) => {
      if (data.status === 1) {
        vm.score -= 3;
        vm.prizeName = data.name;
        data.type === 1 ? vm.actionsClick('showTcc', 'winning') : vm.actionsClick('showTcc', 'game');
      } else if (data.status === -7) {
        vm.score -= 3;
        vm.actionsClick('showTcc', 'tips6');
      } else {
        vm.actionsClick('showTcc', 'tips2');
      }
    });
  },
  // 获取用户已填地址
  getAddr(vm) {
    return fetch(`${url}${getaddr}&id=${vm.addressId}`, '', { }, (data) => {
      if (data.status === 1) {
        vm.addressId = data.user_addr.id;
        vm.mobilePhone = data.user_addr.mobile;
        vm.addressP = data.user_addr.address;
        vm.userNameP = data.user_addr.name;
      } else {
        alert(data.msg)
      }
    });
  },
  // 获取用户获奖记录
  listInfo(vm) {
    vm.show = true;
    return fetch(url + getinfo, '', { }, (data) => {
      vm.show = false;
      if (data.status !== 1) {
        alert(data.msg);
        return false;
      }
      vm.recordingList = data.user_info.choujiang_log;
    });
  },
  // 保存地址
  saveAddress(vm, {
    alogid,
    rname,
    rmobile,
    addrs
  }) {
    return fetch(`${url}${addr}&rname=${rname}&alogid=${alogid}&rmobile=${rmobile}&addr=${addrs}`, '', { }, (data) => {
      data.status === 1 && vm.actionsClick('showTcc', 'tips1');
      data.status !== 1 && alert(data.msg);
    });
  },

  /**
   * 基本配置
   * @returns {*|Promise|Promise.<T>|Promise.<U>}
   */
  getCfg(vm) {
    vm.show = true;
    return fetch(url + getcfg, '', { }, (data) => {
      if (data.cfg_act_status === 1) {
        vm.selectSever = data.cfg_zone_list;
      } else {
        alert(data.cfg_act_status_msg);
      }
      vm.show = false;
    });
  },
  getIndexCfg(vm) {
    return fetch(url + getcfg, '', { }, (data) => {
      if (data.cfg_act_status === 1) {
        vm.startTime = 1;
      } else if (data.cfg_act_status === 0) {
        vm.startTime = 0;
        vm.startTimeMsg = data.cfg_act_status_msg;
      }
    });
  },
  getRole(vm) {
    vm.show = true;
    return fetch(`${url}${getrole}&zone_id=${vm.zoneId}`, '', { }, (data) => {
      data.status === 1 ? (vm.selectCharacter = data.role_list) : alert(data.msg);
      vm.selectItem2 = vm.selectCharacter[0].name;
      vm.roleId = vm.selectCharacter[0].id;
      vm.show = false;
    });
  },

  bindRole(vm) {
    vm.show = true;
    return fetch(`${url}${bindrole}&zone_id=${vm.zoneId}&role_id=${vm.roleId}`, '', { }, (data) => {
      vm.show = false;
      if (data.status === 1) {
        vm.actionsClick('closeTcc', 'binding');
        fetch(url + getinfo, '', { }, (data) => {
          if (data.status !== 1) {
            alert(data.msg);
            return false;
          }
          vm.$emit('roleHandler', '角色:' + data.user_info.role_name);
          // vm.roleName = '角色:' + data.user_info.role_name;
          if (vm.runwx) {
            vm.runwx.wxshare({
              url: vm.shareUrl
            })
          }
        });
      }
      alert(data.msg);
    });
  },
  // 初始化
  getInfo(vm) {
    return fetch(url + getinfo, '', { }, (data) => {
      if (data.status !== 1) {
        alert(data.msg);
        return false;
      }
      vm.yqCounts = data.user_info.share_cnt || 0;
      vm.day_login_act = data.user_info.task_status.day_login_act || 0;
      vm.day_invite_3 = data.user_info.task_status.day_invite_3 || 0;
      vm.active_val_ok = data.user_info.task_status.active_val_ok || 0;
      vm.score = data.user_info.score || 0;
      vm.shareUrl = data.user_info.share_url || location.href;
      vm.recordingList = data.user_info.choujiang_log || [];

      if (data.user_info.role_name !== '') {
        vm.roleName = '角色:' + data.user_info.role_name;
      }

      data.user_info.role_name === '' && vm.actionsClick('showTcc', 'binding');

      if (vm.day_login_act === 1) {
        document.querySelector('#getLq').className += ' on';
        document.querySelector('#getLq').textContent = '已领取';
      }
      if (vm.yqCounts === 1 && vm.day_invite_3 === 0) {
        document.querySelector('#toOver').textContent = '领取';
      }
      if (vm.yqCounts === 1 && vm.day_invite_3 === 1) {
        document.querySelector('#toOver').className += ' on';
        document.querySelector('#toOver').textContent = '已领取';
      }
      if (vm.active_val_ok === 1) {
        document.querySelector('#toLq').className += ' on'
        document.querySelector('#toLq').textContent = '已领取';
      }
      if (vm.runwx) {
        vm.runwx.wxshare({
          url: vm.shareUrl
        })
      }
    });
  },
  cjLog(vm) {
    return fetch(url + cjlog, '', { }, (data) => {
      data.status === 1 && (vm.lukyPerson = data.log);

      if (vm.lukyPerson.length <= 4) {
        vm.config.sCro = 0;
      }

      // for (var i = 0; i < 1e5; i++) {
      //   vm.lukyPerson.push({ who: '186****5564', name: '典藏画册' + i });
      // }
      // vm.lukyPerson.push({ who: '186****5564', name: '结束' });
    });
  }
}
